import { IonListHeader } from '@ionic/react';
import {
  LabelElement,
  RendererProps,
  rankWith,
  uiTypeIs,
} from '@jsonforms/core';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import { ReactElement } from 'react';

interface LabelControllerProps extends RendererProps {}

const IonicLabelControlInner = (props: LabelControllerProps): ReactElement => {
  const { uischema } = props;

  const label = uischema as LabelElement;

  return <IonListHeader>{label.text}</IonListHeader>;
};

const IonicLabelTester = rankWith(1, uiTypeIs('Label'));
const IonicLabelControl = withJsonFormsLayoutProps(IonicLabelControlInner);
export { IonicLabelControl, IonicLabelTester };
